// extracted by mini-css-extract-plugin
module.exports = {"Form":"UploadNewCourse_Form__2nEJJ","Check":"UploadNewCourse_Check__3hP_t","LastScreen":"UploadNewCourse_LastScreen__1RAkz","Button":"UploadNewCourse_Button__1RFwI"};